import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { CommunicationContent, CommunicationContentForm, } from '@src/components/Admin/CommunicationContent';
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useContentType } from '@src/hooks/useContentType';
import { ContentType, useLocale } from 'pe-core-frontend';
import { useNavigate, useParams } from 'react-router-dom';
export const Content = () => {
    const { t } = useLocale();
    const navigate = useNavigate();
    const clientId = useClientIdParam() || 1;
    const { id, tab } = useParams();
    const { type, contentType } = useContentType();
    const isAttestation = type === 'attestations';
    /**
     * It's checking if the tab URL parameter exists. If there's a tab in the URL (like /admin/comms/email), then hasTabParam is true. If there's no tab parameter, it's false.
     * When hasTabParam is true:
     * - The page shows "Email Content" title instead of "Content"
     * - No navigation tabs are displayed
     * - Uses the CommunicationContent component for editing global content by code
     * - Navigates to /admin/comms/{tab} on save/cancel
     *
     * When hasTabParam is false:
     * - Shows "Content" title with "Webpage" and "Attestations" tabs
     * - Uses the CommunicationContentForm component for client-specific content
     * - Navigates to /admin/clients/{clientId}/comms/{type} on save/cancel
     */
    const hasTabParam = !!tab;
    // Check if id is a content code (string) or numeric ID
    const isContentCode = id && isNaN(Number(id));
    const handleCancel = () => {
        if (hasTabParam) {
            navigate(`/admin/comms/${tab}`);
        }
        else {
            navigate(`/admin/clients/${clientId}/comms/${type}`);
        }
    };
    const handleSave = () => {
        // Navigate back after save
        if (hasTabParam) {
            navigate(`/admin/comms/${tab}`);
        }
        else {
            navigate(`/admin/clients/${clientId}/comms/${type}`);
        }
    };
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: hasTabParam ? t('Email Content') : t('Content'), navLinks: hasTabParam
                    ? []
                    : [
                        {
                            title: t('Webpage'),
                            path: `/admin/clients/${clientId}/comms/webpage`,
                            selected: contentType === ContentType.WEBPAGE,
                        },
                        {
                            title: t('Attestations'),
                            path: `/admin/clients/${clientId}/comms/attestations`,
                            selected: isAttestation,
                        },
                    ] }), _jsx("div", { children: hasTabParam && isContentCode ? (_jsx(CommunicationContent, { code: id, contentType: contentType, onSave: handleSave, onCancel: handleCancel })) : (_jsx(CommunicationContentForm, { clientId: clientId, contentId: id === 'new' ? undefined : Number(id), contentType: contentType, type: type, isAttestation: isAttestation, onSave: handleSave, onCancel: handleCancel })) })] }));
};
